module.exports = __webpack_public_path__ + "img/医疗.f8abb623.gif";